export default __webpack_public_path__ + "static/media/rabbitmq.2c73823a.svg";